var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage73({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.5 8.75h5m-5 2.5h5m-6.255 5.243a7.5 7.5 0 1 0-2.735-2.734l-.977 2.918a.625.625 0 0 0 .79.79z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage73);
export default __webpack_public_path__ + "static/media/image73.7d6ed855839c59abac0a27eb1b1ce612.svg";
export { ForwardRef as ReactComponent };